import {gql} from '@apollo/client';
import React from 'react';

import ArchiveModal from 'archive/components/modals/ArchiveModal';
import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {accessibleObjs} from 'graphql-client/InaccessibleInfo';

import {
  ArchiveProcessOutputsQuery,
  ArchiveProcessOutputsQueryVariables,
} from './__generated/ArchiveProcessOutputsQuery';

export const ARCHIVE_PROCESS_OUTPUTS_QUERY = gql`
  query ArchiveProcessOutputsQuery($processOutputIds: [StrictString!]!)
  @skipAudit
  @engComponent(name: WORKFLOWS) {
    processOutputs(ids: $processOutputIds) {
      ... on ProcessOutputNode {
        id
        humanId
        ...HasArchiveRecordGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('HasArchiveRecord').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

interface ArchiveOutputsModalProps {
  outputIds: Array<string>;
  onRequestClose: () => void;
  onRequestSubmit: (submitProps: {itemIds: Array<string>; archivePurpose: string}) => void;
}

export default function ArchiveOutputsModal(props: ArchiveOutputsModalProps): JSX.Element {
  return (
    <BenchlingQuery<ArchiveProcessOutputsQuery, ArchiveProcessOutputsQueryVariables>
      query={ARCHIVE_PROCESS_OUTPUTS_QUERY}
      variables={{processOutputIds: props.outputIds}}
      renderLoading={() => null}
    >
      {(data) => (
        <ArchiveModal
          items={accessibleObjs(data.processOutputs).map(({id, humanId, archiveRecord}) => ({
            id,
            name: humanId,
            archiveRecord,
          }))}
          onRequestClose={props.onRequestClose}
          onArchive={(itemIds: Array<string>, archivePurpose: string) => {
            props.onRequestSubmit({itemIds, archivePurpose});
          }}
        />
      )}
    </BenchlingQuery>
  );
}
